module.exports = __webpack_public_path__ + "static/media/green.76cc75a2.jpg";